import { doorControllerDefaults } from 'helpers/accessControl/defaults'
import mergeWith from 'ramda/src/mergeWith'
import max from 'ramda/src/max'
import mergeDeepRight from 'ramda/src/mergeDeepRight'

/**
 * Expands the model for a door controller
 *
 * @param {Object} doorController - the controller whose model to expand
 * @param {Object} doorControllerModels - the current controller models to use
 * @param {Object} expansionControllerModels - the current expansion controller models to use
 * @return {Object} Door controller with expanded model
 */

const expandDoorControllerModel = (doorController, doorControllerModels, expansionControllerModels) => {
  const modelId = doorController.model.id

  if (!modelId) return doorController

  const model = doorController.isExpansion ? expansionControllerModels.byId[modelId] : doorControllerModels.byId[modelId]

  if (!model) {
    const defaultModel = doorControllerDefaults.model

    return Object.assign({}, doorController, {
      model: Object.assign({}, {
        text: defaultModel.text,
        limits: mergeWith(max, defaultModel.limits, doorController.model.limits)
      }, doorController.model.total_limits && { total_limits: doorController.model.total_limits })
    })
  }

  return Object.assign({}, doorController, { model: mergeDeepRight(model, doorController.model) })
}

export default expandDoorControllerModel



// WEBPACK FOOTER //
// ./src/helpers/accessControl/expandDoorControllerModel.js